export const CNAME_MIN_LENGTH = 3;
export const CNAME_MAX_LENGTH = 40;
export const CNAME_PATTERN = /^[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/;
export const CNAME_DEBOUNCE_IN_MS = 600;
export const CNAME_MAX_AVAILABILITY_ATTEMPTS = 5;
export const CNAME_FALLBACK_PREFIX = 'sav';
export const COMPANY_NAME_DEBOUNCE_IN_MS = 600;
